var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlfa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 34.53H33.29V40H7V34.53ZM14.82 21.62H25.19L26.94 27.12H32.69L24.93 4C24.18 1.78 23.31 0 20.34 0C17.37 0 16.46 1.75 15.68 4L7.56 27.11H12.95L14.82 21.62ZM20.08 6H20.21L23.7 17H16.4L20.08 6Z",
    fill: "#EF3124"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlfa);
export default __webpack_public_path__ + "static/media/alfa.bd81755006c2a494cde0c0cf37911ea2.svg";
export { ForwardRef as ReactComponent };